import React, { useMemo, useState } from 'react';
import {
	Box,
	Drawer,
	DrawerBody,
	DrawerContent,
	DrawerOverlay,
	useBreakpointValue,
	useColorMode,
	useDisclosure,
} from '@chakra-ui/react';
import { useCalendarSettings, useAutoContrastColor, useFilters, useContainerWidth } from '../../../lib';
import { FiltersSlider } from '../../icons';
import { RenderFilters } from './filters';

interface IFiltersDrawerProps {
	border?: boolean;
}

export const FiltersDrawer = ({ border = true }: IFiltersDrawerProps) => {
	const { colorMode } = useColorMode();
	const { settings } = useCalendarSettings();
	const { isOpen, onOpen, onClose } = useDisclosure();
	const isMobile = useBreakpointValue({ base: true, md: false });
	const { filters, searchTerm } = useFilters();
	const [areFiltersApplied, setAreFiltersApplied] = useState(false);
	const { color: iconColor, ref } = useAutoContrastColor();
	const { isNarrow } = useContainerWidth();

	const areFiltersChanged = useMemo(() => {
		const {
			selectedEventTypes,
			selectedEventTags,
			selectedEventLocations,
			selectedCountries,
			selectedStates,
			selectedCities,
		} = filters;

		return (
			selectedEventTypes.length !== 0 ||
			selectedEventTags.length !== 0 ||
			selectedEventLocations.length !== 0 ||
			selectedCountries.length > 0 ||
			selectedStates.length > 0 ||
			selectedCities.length > 0 ||
			searchTerm !== ''
		);
	}, [filters, searchTerm]);

	const { calendarBordersColor, filtersBackgroundColor } = settings.styles[colorMode];
	return (
		<>
			{(!settings.enableCalendarFilters || isMobile || isNarrow) && !settings.showFiltersOnTop && (
				<Box
					ref={ref}
					paddingTop='10px'
					paddingBottom='10px'
					paddingInline='7px'
					margin='0px !important'
					border={border ? `1px solid ${calendarBordersColor}` : ''}
					borderLeft='none'
					onClick={onOpen}
					cursor='pointer'
					position='relative'
				>
					<FiltersSlider size={20} fill={iconColor} />
					{areFiltersApplied && areFiltersChanged && (
						<Box
							position='absolute'
							top='0'
							right='0'
							width='8px'
							height='8px'
							borderRadius='50%'
							backgroundColor='red'
						/>
					)}
				</Box>
			)}
			<Drawer onClose={onClose} isOpen={isOpen} size='xs' placement='left'>
				<DrawerOverlay />
				<DrawerContent>
					<DrawerBody background={filtersBackgroundColor} className='cp-drawer-body'>
						<RenderFilters setAreFiltersApplied={setAreFiltersApplied} onClose={onClose} />
					</DrawerBody>
				</DrawerContent>
			</Drawer>
		</>
	);
};
